export * from './api'
import { GLOBAL_URL } from './api'

export enum PageNameTypeInfo {
    Home = 'Home',
    Proto = 'Proto',
    Person = 'Person',
}
/*播放状态*/
export const SlideItemPlayStatus = {
    Play: 'Play',
    Stop: 'Stop',
    Pause: 'Pause',
}
// 滑动模式
export const SlideType = {
    HORIZONTAL: 0,
    VERTICAL: 1,
    VERTICAL_INFINITE: 2,
}

// 不需要动画的页面
//底部tab的按钮，跳转是不需要用动画的
// export const NO_ANIMATION = ['/', '/video', '/jackpot', '/earnCash', '/wallets', '/cashout', '/events']
export const NO_ANIMATION = ['/']

// 不需要登录的页面
export const NOT_LOGIN = ['/', '/login', '/iosInstruction', '/video', '/jackpot', '/earnCash', '/earn-rule', '/events', '/searchGame']

// 图片背景默认路径

export const BASE_IMG_URL = '/src/assets/img'

// 客服链接
export const CustomerUrl = 'https://t.me/hanfei0100'

export const SMSSIGN = '0ip1DT2c3ZRKX4w5'

//手机号区号国家
export const COUNTRY_PHONE_CONFIG = [
    { code: '63', value: 'PH', nameEn: 'Philippines', nameLocal: 'Pilipinas' },
    { code: '1', value: 'US', nameEn: 'United States', nameLocal: '' },
    { code: '90', value: 'TR', nameEn: 'Turkey', nameLocal: 'Türkiye' },
    { code: '55', value: 'BR', nameEn: 'Brazil', nameLocal: 'Brasil' },
    { code: '234', value: 'NG', nameEn: 'Nigeria', nameLocal: '' },
    { code: '62', value: 'ID', nameEn: 'Indonesia', nameLocal: 'Indonesia' },
    { code: '91', value: 'IN', nameEn: 'India', nameLocal: 'भारत' },
    { code: '852', value: 'HK', nameEn: 'Hong Kong', nameLocal: '香港' },
    { code: '966', value: 'SA', nameEn: 'Saudi Arabia', nameLocal: 'المملكة العربية السعودية' },
    { code: '65', value: 'SG', nameEn: 'Singapore', nameLocal: '' },
    { code: '49', value: 'DE', nameEn: 'Germany', nameLocal: 'Deutschland' },
    { code: '965', value: 'KW', nameEn: 'Kuwait', nameLocal: 'الكويت' },
    { code: '36', value: 'HU', nameEn: 'Hungary', nameLocal: 'Magyarország' },
    { code: '64', value: 'NZ', nameEn: 'New Zealand', nameLocal: '' },
    { code: '81', value: 'JP', nameEn: 'Japan', nameLocal: '日本' },
    { code: '61', value: 'AU', nameEn: 'Australia', nameLocal: '' },
    { code: '974', value: 'QA', nameEn: 'Qatar', nameLocal: 'قطر' },
    { code: '971', value: 'AE', nameEn: 'United Arab Emirates', nameLocal: 'الإمارات العربية المتحدة' },
    { code: '244', value: 'AO', nameEn: 'Angola', nameLocal: 'Angola' },
    { code: '93', value: 'AF', nameEn: 'Afghanistan', nameLocal: 'افغانستان' },
    { code: '355', value: 'AL', nameEn: 'Albania', nameLocal: 'Shqipëri' },
    { code: '213', value: 'DZ', nameEn: 'Algeria', nameLocal: 'الجزائر' },
    { code: '376', value: 'AD', nameEn: 'Andorra', nameLocal: 'Andorra' },
    { code: '1264', value: 'AI', nameEn: 'Anguilla', nameLocal: '' },
    { code: '1268', value: 'AG', nameEn: 'Antigua and Barbuda', nameLocal: '' },
    { code: '54', value: 'AR', nameEn: 'Argentina', nameLocal: 'Argentina' },
    { code: '374', value: 'AM', nameEn: 'Armenia', nameLocal: 'Հայաստան' },
    { code: '247', value: 'AC', nameEn: 'Ascension Island', nameLocal: '' },
    { code: '43', value: 'AT', nameEn: 'Austria', nameLocal: 'Österreich' },
    { code: '994', value: 'AZ', nameEn: 'Azerbaijan', nameLocal: 'Azərbaycan' },
    { code: '1242', value: 'BS', nameEn: 'Bahamas', nameLocal: '' },
    { code: '973', value: 'BH', nameEn: 'Bahrain', nameLocal: 'البحرين' },
    { code: '880', value: 'BD', nameEn: 'Bangladesh', nameLocal: 'বাংলাদেশ' },
    { code: '1246', value: 'BB', nameEn: 'Barbados', nameLocal: '' },
    { code: '375', value: 'BY', nameEn: 'Belarus', nameLocal: 'Беларусь' },
    { code: '32', value: 'BE', nameEn: 'Belgium', nameLocal: 'België' },
    { code: '501', value: 'BZ', nameEn: 'Belize', nameLocal: '' },
    { code: '229', value: 'BJ', nameEn: 'Benin', nameLocal: 'Bénin' },
    { code: '1441', value: 'BM', nameEn: 'Bermuda', nameLocal: '' },
    { code: '591', value: 'BO', nameEn: 'Bolivia', nameLocal: 'Bolivia' },
    { code: '267', value: 'BW', nameEn: 'Botswana', nameLocal: '' },
    { code: '673', value: 'BN', nameEn: 'Brunei', nameLocal: '' },
    { code: '359', value: 'BG', nameEn: 'Bulgaria', nameLocal: 'България' },
    { code: '226', value: 'BF', nameEn: 'Burkina Faso', nameLocal: 'Burkina Faso' },
    { code: '95', value: 'MM', nameEn: 'Myanmar', nameLocal: 'မြန်မာ' },
    { code: '257', value: 'BI', nameEn: 'Burundi', nameLocal: 'Burundi' },
    { code: '237', value: 'CM', nameEn: 'Cameroon', nameLocal: 'Cameroun' },
    { code: '1', value: 'CA', nameEn: 'Canada', nameLocal: '' },
    { code: '1345', value: 'KY', nameEn: 'Cayman Islands', nameLocal: '' },
    { code: '236', value: 'CF', nameEn: 'Central African Republic', nameLocal: 'République centrafricaine' },
    { code: '235', value: 'TD', nameEn: 'Chad', nameLocal: 'Tchad' },
    { code: '56', value: 'CL', nameEn: 'Chile', nameLocal: 'Chile' },
    { code: '57', value: 'CO', nameEn: 'Colombia', nameLocal: 'Colombia' },
    { code: '242', value: 'CG', nameEn: 'Republic of the Congo', nameLocal: 'République du Congo' },
    { code: '682', value: 'CK', nameEn: 'Cook Islands', nameLocal: '' },
    { code: '506', value: 'CR', nameEn: 'Costa Rica', nameLocal: 'Costa Rica' },
    { code: '53', value: 'CU', nameEn: 'Cuba', nameLocal: 'Cuba' },
    { code: '357', value: 'CY', nameEn: 'Cyprus', nameLocal: 'Κύπρος' },
    { code: '420', value: 'CZ', nameEn: 'Czech Republic', nameLocal: 'Česká republika' },
    { code: '45', value: 'DK', nameEn: 'Denmark', nameLocal: 'Danmark' },
    { code: '253', value: 'DJ', nameEn: 'Djibouti', nameLocal: 'Djibouti' },
    { code: '1890', value: 'DO', nameEn: 'Dominican Republic', nameLocal: 'República Dominicana' },
    { code: '593', value: 'EC', nameEn: 'Ecuador', nameLocal: 'Ecuador' },
    { code: '20', value: 'EG', nameEn: 'Egypt', nameLocal: 'مصر' },
    { code: '503', value: 'SV', nameEn: 'El Salvador', nameLocal: 'El Salvador' },
    { code: '372', value: 'EE', nameEn: 'Estonia', nameLocal: 'Eesti' },
    { code: '251', value: 'ET', nameEn: 'Ethiopia', nameLocal: 'ኢትዮጵያ' },
    { code: '679', value: 'FJ', nameEn: 'Fiji', nameLocal: '' },
    { code: '358', value: 'FI', nameEn: 'Finland', nameLocal: 'Suomi' },
    { code: '33', value: 'FR', nameEn: 'France', nameLocal: 'France' },
    { code: '594', value: 'GF', nameEn: 'French Guiana', nameLocal: 'Guyane française' },
    { code: '241', value: 'GA', nameEn: 'Gabon', nameLocal: 'Gabon' },
    { code: '220', value: 'GM', nameEn: 'Gambia', nameLocal: '' },
    { code: '995', value: 'GE', nameEn: 'Georgia', nameLocal: 'საქართველო' },
    { code: '233', value: 'GH', nameEn: 'Ghana', nameLocal: '' },
    { code: '350', value: 'GI', nameEn: 'Gibraltar', nameLocal: '' },
    { code: '30', value: 'GR', nameEn: 'Greece', nameLocal: 'Ελλάδα' },
    { code: '1809', value: 'GD', nameEn: 'Grenada', nameLocal: '' },
    { code: '1671', value: 'GU', nameEn: 'Guam', nameLocal: '' },
    { code: '502', value: 'GT', nameEn: 'Guatemala', nameLocal: 'Guatemala' },
    { code: '224', value: 'GN', nameEn: 'Guinea', nameLocal: 'Guinée' },
    { code: '592', value: 'GY', nameEn: 'Guyana', nameLocal: '' },
    { code: '509', value: 'HT', nameEn: 'Haiti', nameLocal: 'Haïti' },
    { code: '504', value: 'HN', nameEn: 'Honduras', nameLocal: 'Honduras' },
    { code: '354', value: 'IS', nameEn: 'Iceland', nameLocal: 'Ísland' },
    { code: '98', value: 'IR', nameEn: 'Iran', nameLocal: 'ایران' },
    { code: '964', value: 'IQ', nameEn: 'Iraq', nameLocal: 'العراق' },
    { code: '353', value: 'IE', nameEn: 'Ireland', nameLocal: '' },
    { code: '972', value: 'IL', nameEn: 'Israel', nameLocal: 'ישראל' },
    { code: '39', value: 'IT', nameEn: 'Italy', nameLocal: 'Italia' },
    { code: '1876', value: 'JM', nameEn: 'Jamaica', nameLocal: '' },
    { code: '962', value: 'JO', nameEn: 'Jordan', nameLocal: 'الأردن' },
    { code: '855', value: 'KH', nameEn: 'Cambodia', nameLocal: 'កម្ពុជា' },
    { code: '327', value: 'KZ', nameEn: 'Kazakhstan', nameLocal: 'Қазақстан' },
    { code: '254', value: 'KE', nameEn: 'Kenya', nameLocal: '' },
    { code: '82', value: 'KR', nameEn: 'South Korea', nameLocal: '대한민국' },
    { code: '331', value: 'KG', nameEn: 'Kyrgyzstan', nameLocal: 'Кыргызстан' },
    { code: '856', value: 'LA', nameEn: 'Laos', nameLocal: 'ລາວ' },
    { code: '371', value: 'LV', nameEn: 'Latvia', nameLocal: 'Latvija' },
    { code: '961', value: 'LB', nameEn: 'Lebanon', nameLocal: 'لبنان' },
    { code: '266', value: 'LS', nameEn: 'Lesotho', nameLocal: '' },
    { code: '231', value: 'LR', nameEn: 'Liberia', nameLocal: '' },
    { code: '218', value: 'LY', nameEn: 'Libya', nameLocal: 'ليبيا' },
    { code: '423', value: 'LI', nameEn: 'Liechtenstein', nameLocal: 'Liechtenstein' },
    { code: '370', value: 'LT', nameEn: 'Lithuania', nameLocal: 'Lietuva' },
    { code: '352', value: 'LU', nameEn: 'Luxembourg', nameLocal: 'Luxembourg' },
    { code: '853', value: 'MO', nameEn: 'Macau', nameLocal: '澳門' },
    { code: '261', value: 'MG', nameEn: 'Madagascar', nameLocal: 'Madagasikara' },
    { code: '265', value: 'MW', nameEn: 'Malawi', nameLocal: '' },
    { code: '60', value: 'MY', nameEn: 'Malaysia', nameLocal: 'Malaysia' },
    { code: '960', value: 'MV', nameEn: 'Maldives', nameLocal: 'ދިވެހިރާއްޖެ' },
    { code: '223', value: 'ML', nameEn: 'Mali', nameLocal: 'Mali' },
    { code: '356', value: 'MT', nameEn: 'Malta', nameLocal: '' },
    { code: '596', value: 'MQ', nameEn: 'Martinique', nameLocal: 'Martinique' },
    { code: '230', value: 'MU', nameEn: 'Mauritius', nameLocal: '' },
    { code: '52', value: 'MX', nameEn: 'Mexico', nameLocal: 'México' },
    { code: '373', value: 'MD', nameEn: 'Moldova', nameLocal: 'Moldova' },
    { code: '377', value: 'MC', nameEn: 'Monaco', nameLocal: 'Monaco' },
    { code: '976', value: 'MN', nameEn: 'Mongolia', nameLocal: 'Монгол' },
    { code: '1664', value: 'MS', nameEn: 'Montserrat', nameLocal: '' },
    { code: '212', value: 'MA', nameEn: 'Morocco', nameLocal: 'المغرب' },
    { code: '258', value: 'MZ', nameEn: 'Mozambique', nameLocal: 'Moçambique' },
    { code: '264', value: 'NA', nameEn: 'Namibia', nameLocal: '' },
    { code: '674', value: 'NR', nameEn: 'Nauru', nameLocal: '' },
    { code: '977', value: 'NP', nameEn: 'Nepal', nameLocal: 'नेपाल' },
    { code: '31', value: 'NL', nameEn: 'Netherlands', nameLocal: 'Nederland' },
    { code: '505', value: 'NI', nameEn: 'Nicaragua', nameLocal: 'Nicaragua' },
    { code: '227', value: 'NE', nameEn: 'Niger', nameLocal: 'Niger' },
    { code: '850', value: 'KP', nameEn: 'North Korea', nameLocal: '조선민주주의인민공화국' },
    { code: '47', value: 'NO', nameEn: 'Norway', nameLocal: 'Norge' },
    { code: '968', value: 'OM', nameEn: 'Oman', nameLocal: 'عُمان' },
    { code: '92', value: 'PK', nameEn: 'Pakistan', nameLocal: 'پاکستان' },
    { code: '507', value: 'PA', nameEn: 'Panama', nameLocal: 'Panamá' },
    { code: '675', value: 'PG', nameEn: 'Papua New Guinea', nameLocal: '' },
    { code: '595', value: 'PY', nameEn: 'Paraguay', nameLocal: 'Paraguay' },
    { code: '51', value: 'PE', nameEn: 'Peru', nameLocal: 'Perú' },
    { code: '48', value: 'PL', nameEn: 'Poland', nameLocal: 'Polska' },
    { code: '689', value: 'PF', nameEn: 'French Polynesia', nameLocal: 'Polynésie française' },
    { code: '351', value: 'PT', nameEn: 'Portugal', nameLocal: 'Portugal' },
    { code: '1787', value: 'PR', nameEn: 'Puerto Rico', nameLocal: '' },
    { code: '262', value: 'RE', nameEn: 'Réunion', nameLocal: 'Réunion' },
    { code: '40', value: 'RO', nameEn: 'Romania', nameLocal: 'România' },
    { code: '7', value: 'RU', nameEn: 'Russia', nameLocal: 'Россия' },
    { code: '1758', value: 'LC', nameEn: 'Saint Lucia', nameLocal: '' },
    { code: '1784', value: 'VC', nameEn: 'Saint Vincent and the Grenadines', nameLocal: '' },
    { code: '684', value: 'AS', nameEn: 'American Samoa', nameLocal: '' },
    { code: '685', value: 'WS', nameEn: 'Samoa', nameLocal: '' },
    { code: '378', value: 'SM', nameEn: 'San Marino', nameLocal: 'San Marino' },
    { code: '239', value: 'ST', nameEn: 'São Tomé and Príncipe', nameLocal: 'São Tomé e Príncipe' },
    { code: '221', value: 'SN', nameEn: 'Senegal', nameLocal: 'Sénégal' },
    { code: '248', value: 'SC', nameEn: 'Seychelles', nameLocal: '' },
    { code: '232', value: 'SL', nameEn: 'Sierra Leone', nameLocal: '' },
    { code: '421', value: 'SK', nameEn: 'Slovakia', nameLocal: 'Slovensko' },
    { code: '386', value: 'SI', nameEn: 'Slovenia', nameLocal: 'Slovenija' },
    { code: '677', value: 'SB', nameEn: 'Solomon Islands', nameLocal: '' },
    { code: '252', value: 'SO', nameEn: 'Somalia', nameLocal: 'Soomaaliya' },
    { code: '27', value: 'ZA', nameEn: 'South Africa', nameLocal: '' },
    { code: '34', value: 'ES', nameEn: 'Spain', nameLocal: 'España' },
    { code: '94', value: 'LK', nameEn: 'Sri Lanka', nameLocal: 'ශ්‍රී ලංකා' },
    { code: '249', value: 'SD', nameEn: 'Sudan', nameLocal: 'السودان' },
    { code: '211', value: 'SS', nameEn: 'South Sudan', nameLocal: '' },
    { code: '597', value: 'SR', nameEn: 'Suriname', nameLocal: 'Suriname' },
    { code: '268', value: 'SZ', nameEn: 'Eswatini', nameLocal: '' },
    { code: '46', value: 'SE', nameEn: 'Sweden', nameLocal: 'Sverige' },
    { code: '41', value: 'CH', nameEn: 'Switzerland', nameLocal: 'Schweiz' },
    { code: '963', value: 'SY', nameEn: 'Syria', nameLocal: 'سوريا' },
    { code: '886', value: 'TW', nameEn: 'Taiwan', nameLocal: '台灣' },
    { code: '992', value: 'TJ', nameEn: 'Tajikistan', nameLocal: 'Тоҷикистон' },
    { code: '255', value: 'TZ', nameEn: 'Tanzania', nameLocal: '' },
    { code: '66', value: 'TH', nameEn: 'Thailand', nameLocal: 'ไทย' },
    { code: '228', value: 'TG', nameEn: 'Togo', nameLocal: 'Togo' },
    { code: '676', value: 'TO', nameEn: 'Tonga', nameLocal: '' },
    { code: '1809', value: 'TT', nameEn: 'Trinidad and Tobago', nameLocal: '' },
    { code: '216', value: 'TN', nameEn: 'Tunisia', nameLocal: 'تونس' },
    { code: '993', value: 'TM', nameEn: 'Turkmenistan', nameLocal: 'Türkmenistan' },
    { code: '256', value: 'UG', nameEn: 'Uganda', nameLocal: '' },
    { code: '380', value: 'UA', nameEn: 'Ukraine', nameLocal: 'Україна' },
    { code: '44', value: 'GB', nameEn: 'United Kingdom', nameLocal: '' },
    { code: '598', value: 'UY', nameEn: 'Uruguay', nameLocal: 'Uruguay' },
    { code: '998', value: 'UZ', nameEn: 'Uzbekistan', nameLocal: 'Oʻzbekiston' },
    { code: '58', value: 'VE', nameEn: 'Venezuela', nameLocal: 'Venezuela' },
    { code: '84', value: 'VN', nameEn: 'Vietnam', nameLocal: 'Việt Nam' },
    { code: '967', value: 'YE', nameEn: 'Yemen', nameLocal: 'اليمن' },
    { code: '263', value: 'ZW', nameEn: 'Zimbabwe', nameLocal: '' },
    { code: '243', value: 'CD', nameEn: 'Democratic Republic of the Congo', nameLocal: 'République démocratique du Congo' },
    { code: '260', value: 'ZM', nameEn: 'Zambia', nameLocal: '' },
]

// 提现状态
export const GCASH_PAYStATE = {
    0: 'Unreviewed',
    1: 'Reviewed_order_is_withdrawal',
    3: 'Withdrawal_successful',
    2: 'Withdrawal_Failed',
    4: 'Review_failed',
    5: 'To_be_determined',
    6: 'Cancel',
}
// 系统消息前缀
export const SYSTEM = 10000
// 交易消息前缀
export const TRANSACtiON = 20000

export enum MESSAGE_CODE {
    SYSTEM = 10000, // 系统
    TRANSACTION = 20000, // 交易
}

// 未登录时长链接请求缓存黑名单
export const BLACK_LIST = [GLOBAL_URL.SessionLogin]

export const CUREENCY_SYMBOL = {
    PHP: 'P',
    USD: '$',
}
export const CACHE_HOST_LIST = ['cach', 'cach1', 'cach2', 'cach3', 'cach4', 'cach5']

// vip 权益图标
export const VIP_LEGAL_CONFIG = [
    {
        text: 'vip_reward1',
        key: 'reward.gold',
    },
    {
        text: 'vip_reward2',
        key: 'monthReward.gold',
    },
    {
        text: 'vip_reward3',
        key: 'betRebate',
        type: 'percent',
    },
    {
        text: 'vip_reward4',
        key: 'depositBonus',
        type: 'percent',
    },
    {
        text: 'vip_reward5',
        key: 'benefit',
    },
    {
        text: 'vip_reward6',
        key: 'withdrawAmount',
    },
    {
        text: 'vip_reward7',
        key: 'withdrawTimes',
    },
]
export const FORMATE_CURRENCY = ['IDR', 'NGN']

// 长链接
export const WS_HOST = {
    development: ['wss://tests0.betfuguapi.com'],
    production: ['wss://acc.betfuguapi.com'],
}

export const WS_SERVER = WS_HOST[import.meta.env.MODE]

export const CURRENCY_ENV = {
    development: [
        {
            currency: 'PHP',
            type: 1,
            picture: 'https://resource.betfugu.com/currencyicon/BphzDWQwsm.png',
            clientcurrency: '₱',
            exchangeRate: '0.017',
            country: 'PH',
            language: 'tl-PH',
        },
        {
            currency: 'INR',
            type: 1,
            picture: 'https://resource.betfugu.com/currencyicon/S5rpyZBwwT.png',
            clientcurrency: '₹',
            exchangeRate: '0.01166',
            country: 'IN',
            language: 'en-US',
        },
        {
            currency: 'BDT',
            type: 1,
            picture: 'https://resource.betfugu.com/currencyicon/7abcjAY8nE.png',
            clientcurrency: '৳',
            exchangeRate: '0.0082',
            country: 'BD',
            language: 'en-US',
        },
        // {
        //     currency: 'IDR',
        //     type: 1,
        //     picture: 'https://betfugu.com/image/currencyicon/24ecbe85-b1d2-44a4-a34e-7a79be5e61d1.png',
        //     clientcurrency: 'Rp',
        //     exchangeRate: '0.00006168',
        // },

        // {
        //     currency: 'BRL',
        //     type: 1,
        //     picture: 'https://betfugu.com/image/currencyicon/c6fc626a-b7c6-4c10-b7cb-dec78f1833ac.png',
        //     clientcurrency: 'R$',
        //     exchangeRate: '0.16',
        // },
        {
            currency: 'NGN',
            type: 1,
            picture: 'https://resource.betfugu.com/currencyicon/GXpWQK3Miw.png',
            clientcurrency: '₦',
            exchangeRate: '0.00064',
            language: 'en-US',
            country: 'NG',
        },
        {
            currency: 'USDT',
            type: 1,
            picture: 'https://resource.betfugu.com/currencyicon/FwNCaWk4m4.png',
            clientcurrency: '$',
            exchangeRate: '1',
            language: 'en-US',
        },
        // {
        //     currency: 'TRY',
        //     type: 1,
        //     picture: 'https://betfugu.com/image/currencyicon/3d9e634d-f7b7-46b4-b7c4-8130c41ce7fa.png',
        //     clientcurrency: '₺',
        //     exchangeRate: '0.028',
        // },
        {
            currency: 'KES',
            type: 1,
            picture: 'https://resource.betfugu.com/currencyicon/KaRJaECKft.png',
            clientcurrency: 'KSh',
            exchangeRate: '0.0001',
            language: 'en-US',
        },
    ],
    production: [
        {
            currency: 'PHP',
            type: 1,
            picture: 'https://resource.betfugu.com/currencyicon/BphzDWQwsm.png',
            clientcurrency: '₱',
            exchangeRate: '0.017',
            country: 'PH',
            language: 'tl-PH',
        },
        {
            currency: 'INR',
            type: 1,
            picture: 'https://resource.betfugu.com/currencyicon/S5rpyZBwwT.png',
            clientcurrency: '₹',
            exchangeRate: '0.01166',
            country: 'IN',
            language: 'en-US',
        },
        {
            currency: 'BDT',
            type: 1,
            picture: 'https://resource.betfugu.com/currencyicon/7abcjAY8nE.png',
            clientcurrency: '৳',
            exchangeRate: '0.0082',
            country: 'BD',
            language: 'en-US',
        },

        // {
        //     currency: 'NGN',
        //     type: 1,
        //     picture: 'https://resource.betfugu.com/currencyicon/GXpWQK3Miw.png',
        //     clientcurrency: '₦',
        //     exchangeRate: '0.00064',
        // },

        {
            currency: 'USD',
            type: 1,
            picture: 'https://resource.betfugu.com/currencyicon/FwNCaWk4m4.png',
            clientcurrency: '$',
            exchangeRate: '1',
            language: 'en-US',
        },
        // {
        //     currency: 'TRY',
        //     type: 1,
        //     picture: 'https://betfugu.com/image/currencyicon/55fae9ef-75da-4eb3-9477-7edf224c1698.png',
        //     clientcurrency: '₺',
        //     exchangeRate: '0.028',
        // },
        // {
        //     currency: 'BRL',
        //     type: 1,
        //     picture: 'https://betfugu.com/image/currencyicon/80496525-fc06-4f31-9289-b8465bf91087.png',
        //     clientcurrency: 'R$',
        //     exchangeRate: '0.16',
        // },
        {
            currency: 'NGN',
            type: 1,
            picture: 'https://resource.betfugu.com/currencyicon/GXpWQK3Miw.png',
            clientcurrency: '₦',
            exchangeRate: '0.00064',
            country: 'NG',
            language: 'en-US',
        },
        {
            currency: 'USDT',
            type: 1,
            picture: 'https://resource.betfugu.com/currencyicon/FwNCaWk4m4.png',
            clientcurrency: '$',
            exchangeRate: '1',
        },
        {
            currency: 'KES',
            type: 1,
            picture: 'https://resource.betfugu.com/currencyicon/KaRJaECKft.png',
            clientcurrency: 'KSh',
            exchangeRate: '0.0001',
            language: 'en-US',
        },
    ],
}
export const CURRENCY_LIST = CURRENCY_ENV[import.meta.env.MODE]

export const LANGUAGE_ENV = {
    development: [
        {
            language: 'en-US',
            show: 'English(US)',
        },
        {
            language: 'tl-PH',
            show: 'Filipino',
        },

        // {
        //     language: 'hi-IN',
        //     show: 'हिंदी',
        // },
        // {
        //     language: 'pt-BR',
        //     show: 'Português',
        // },
        // {
        //     language: 'id-ID',
        //     show: 'Indonesia',
        // },
        // {
        //     language: 'tr-TR',
        //     show: 'Türkçe',
        // },
    ],
    production: [
        {
            language: 'en-US',
            show: 'English',
        },
        {
            language: 'tl-PH',
            show: 'Filipino',
        },
        // {
        //     language: 'tr-TR',
        //     show: 'Türkçe',
        // },
        // {
        //     language: 'pt-BR',
        //     show: 'Português',
        // },
    ],
}
export const LANGUAGE_LIST = LANGUAGE_ENV[import.meta.env.MODE]

export const USDTChainList = [
    'ERC20',
    'BEP20',
    'TRC20',
    'BTC',
    'LTC',
    'DOGE',
    'SOL',
    'POLYGON',
    'XRP',
    'XLM',
    'ARETH',
    'OPTIMISM',
    'AVAX',
    'BASE',
    'TON',
    'SUI',
    'DOT',
    'KSM',
    'ZIL',
    'NEAR',
    'DGB',
    'OPBNB',
    'HBAR',
    'BITTENSOR',
    'TEZOS',
    'HYPE',
    'WAX',
    'THETA',
]

export const BankNameList = [
    '9 Payment Service Bank',
    'AB MICROFINANCE BANK',
    'ABBEY MORTGAGE BANK',
    'ABOVE ONLY MICROFINANCE BANK',
    'ABU MICROFINANCE BANK',
    'ACCESS YELLO & BETA',
    'ACCION MICROFINANCE BANK',
    'ADDOSSER MICROFINANCE BANK',
    'ADEYEMI COLLEGE STAFF MICROFINANCE BANK',
    'AFEKHAFE MICROFINANCE BANK',
    'AG MORTGAGE BANK',
    'AL-BARAKAH MICROFINANCE BANK',
    'ALEKUN MICROFINANCE BANK',
    'ALERT MICROFINANCE BANK',
    'ALLWORKERS MICROFINANCE BANK',
    'ALPHA KAPITAL MICROFINANCE BANK',
    'APEKS MICROFINANCE BANK',
    'ARISE MICROFINANCE BANK',
    'ASSETMATRIX MICROFINANCE BANK',
    'ASTRAPOLARIS MICROFINANCE BANK',
    'AUCHI MICROFINANCE BANK',
    'BAINES CREDIT MICROFINANCE BANK',
    'BALOGUN GAMBARI MICROFINANCE BANK',
    'BC KASH MICROFINANCE BANK',
    'BIPC MICROFINANCE BANK',
    'BOSAK MICROFINANCE BANK',
    'BRENT MORTGAGE BANK',
    'BRIGHTWAY MICROFINANCE BANK',
    'CASHCONNECT MICROFINANCE BANK',
    'CEMCS Microfinance Bank',
    'CHIKUM MICROFINANCE BANK',
    'CIT MICROFINANCE BANK',
    'COASTLINE MICROFINANCE BANK',
    'CONPRO MICROFINANCE BANK',
    'CONSUMER MICROFINANCE BANK',
    'CONTEC GLOBAL INFOTECH LIMITED(NOWNOW)',
    'CORESTEP MICROFINANCE BANK',
    'CREDIT AFRIQUE MICROFINANCE BANK',
    'DAVODANI MICROFINANCE BANK',
    'DAYLIGHT MICROFINANCE BANK',
    'E-BARCS MICROFINANCE BANK',
    'EAGLE FLIGHT MICROFINANCE BANK',
    'EK-RELIABLE MICROFINANCE BANK',
    'EKONDO MICROFINANCE BANK',
    'EMERALD MICROFINANCE BANK',
    'ESO-E MICROFINANCE BANK',
    'EVANGEL MICROFINANCE BANK',
    'EVERGREEN MICROFINANCE BANK',
    'FAST MICROFINANCE BANK',
    'FCMB Easy Account',
    'FCT MICROFINANCE BANK',
    'FEDPOLY NASARAWA MICROFINANCE BANK',
    'FFS MICROFINANCE BANK',
    'FIDFUND MICROFINANCE Bank',
    'FINATRUST MICROFINANCE BANK',
    'FINCA MICROFINANCE BANK',
    'FIRMUS MICROFINANCE BANK',
    'FIRST GENERATION MORTGAGE BANK',
    'FIRST OPTION MICROFINANCE BANK',
    'FSDH Merchant Bank',
    'FULLRANGE MICROFINANCE BANK',
    'FUTO MICROFINANCE BANK',
    'GATEWAY MORTGAGE BANK',
    'GLORY MICROFINANCE BANK',
    'GOWANS MICROFINANCE BANK',
    'GREENBANK MICROFINANCE BANK',
    'GROOMING MICROFINANCE BANK',
    'GTI MICROFINANCE BANK',
    'HAGGAI MORTGAGE BANK LIMITED',
    'HEADWAY MICROFINANCE BANK',
    'IKENNE MICROFINANCE BANK',
    'IKIRE MICROFINANCE BANK',
    'IKIRE MICROFINANCE BANK',
    'ILISAN MICROFINANCE BANK',
    'IMO STATE MICROFINANCE BANK',
    'INFINITY TRUST MORTGAGE BANK',
    'INTERLAND MICROFINANCE BANK',
    'IRL MICROFINANCE BANK',
    'ISALEOYO MICROFINANCE BANK',
    'KONTAGORA MICROFINANCE BANK',
    'Kuda MFB',
    'LAGOS BUILDING AND INVESTMENT COMPANY',
    'Lagos Building Investment Company Plc.',
    'LAPO MICROFINANCE BANK',
    'LAVENDER MICROFINANCE BANK',
    'LEGEND MICROFINANCE BANK',
    'MAINSTREET MICROFINANCE BANK',
    'MANNY MICROFINANCE BANK',
    'MAYFAIR MICROFINANCE BANK',
    'MAYFRESH MORTGAGE BANK',
    'MEGAPRAISE MICROFINANCE BANK',
    'MICROCRED MICROFINANCE BANK',
    'MICROVIS MICROFINANCE BANK',
    'MINT-FINEX MFB',
    'MOLUSI MICROFINANCE BANK',
    'MOZFIN MICROFINANCE BANK',
    'MUTUAL TRUST MICROFINANCE BANK',
    'NDIORAH MICROFINANCE BANK',
    'NEPTUNE MICROFINANCE BANK',
    'NEW DAWN MICROFINANCE BANK',
    'NEW GOLDEN PASTURES MICROFINANCE BANK',
    'NIGERIAN NAVY MICROFINANCE BANK',
    'NIRSAL NATIONAL MICROFINANCE BANK',
    'NNEW WOMEN MICROFINANCE BANK',
    'NUTURE MICROFINANCE BANK',
    'NWANNEGADI MICROFINANCE BANK',
    'OCHE MICROFINANCE BANK',
    'OHAFIA MICROFINANCE BANK',
    'OKPOGA MICROFINANCE BANK',
    'OLABISI ONABANJO UNIVERSITY MICROFINANCE',
    'OMIYE MICROFINANCE BANK',
    'PAGA',
    'PALMPAY',
    'PATRICKGOLD MICROFINANCE BANK',
    'PECANTRUST MICROFINANCE BANK',
    'PENNYWISE MICROFINANCE BANK',
    'PERSONAL TRUST MICROFINANCE BANK',
    'PILLAR MICROFINANCE BANK',
    'PLATINUM MORTGAGE BANK',
    'POLYUNWANA MICROFINANCE BANK',
    'PRESTIGE MICROFINANCE BANK',
    'PURPLEMONEY MICROFINANCE BANK',
    'QUICKFUND MICROFINANCE BANK',
    'REFUGE MORTGAGE BANK',
    'Rehoboth Microfinance bank',
    'RENMONEY MICROFINANCE BANK',
    'REPHIDIM MICROFINANCE BANK',
    'RICHWAY MICROFINANCE BANK',
    'ROYAL EXCHANGE MICROFINANCE BANK',
    'Rubies Microfinance Bank',
    'SAFE HAVEN MICROFINANCE BANK',
    'SEEDVEST MICROFINANCE BANK',
    'STELLAS MICROFINANCE BANK',
    'SULSPAP MICROFINANCE BANK',
    'THINK FINANCE MICROFINANCE BANK',
    'TRIDENT MICROFINANCE BANK',
    'TRUST MICROFINANCE BANK',
    'Verite Microfinance Bank',
    'TRUSTFUND MICROFINANCE BANK NIBSS F.I.',
    'U & C MICROFINANCE BANK',
    'UNAAB MICROFINANCE BANK',
    'UNIVERSITY OF NIGERIA, NSUKKA MICROFINANCE BANK',
    'VIRTUE MICROFINANCE BANK',
    'VISA MICROFINANCE BANK',
    'XSLNCE MICROFINANCE BANK',
    'YES MICROFINANCE BANK',
    'YOBE MICROFINANCE BANK',
    'One Finance',
    'Zinternet Nigera Limited',
    'Omoluabi Mortgage Bank Plc',
    '3line Card management',
    '78 FINANCE COMPANY',
    '9JAPAY MICROFINANCE',
    'ABSU MICROFINANCE BANK',
    'AELLA MICROFINANCE BANK',
    'AKU MICROFINANCE BANK',
    'ALTERNATIVE BANK',
    'AMML MFB',
    'ASOSavings',
    'AVUENEGBE MICROFINANCE BANK',
    'ASOSavings',
    'Abucoop Microfinance Bank',
    'Access Bank',
    'AccessMobile',
    'FINCA MICROFINANCE',
    'Amac Microfinance Bank',
    'AMJU UNIQUE MICROFINANCE BANK',
    'Amucha Microfinance Bank',
    'Aspire Microfinance Bank',
    'BAM MICROFINANCE BANK',
    'BELLBANK MICROFINANC',
    'BERACHAH MICROFINANCE BANK',
    'BETHEL MICROFINANCE BANK',
    'BOKKOS MICROFINANCE BANK',
    'BUILD MICROFINANCE BANK',
    'BUNDI MICROFINANCE BANK',
    'BUNKURE MICROFINANCE BANK',
    'BUYPOWER MICROFINANCE BANK',
    'Beststar MICROFINANCE BANK',
    'Boctrust Microfinance Bank',
    'Bowen Microfinance Bank',
    'Branch Int Financial Services',
    'Brent Mortgage Bank',
    'CANAAN MICROFINANCE BANK',
    'CEMCS MFB',
    'KOLOMONI MICROFINANCE BANK',
    'CITYCODE MORTGAGE BANK',
    'COUNTY FINANCE',
    'CRUST MICROFINANCE BANK',
    'CSD MICROFINANCE BANK',
    'Calabar Microfinance Bank',
    'ChamsMobile',
    'Chibueze Microfinance Bank',
    'Citi Bank',
    'Coronation',
    'Covenant',
    'CrossRiver Microfinance Bank',
    'DAL MICROFINANCE BANK',
    'DELTA TRUST MORTGAGE BANK',
    'DOT MICROFINANCE BANK',
    'EBSU MICROFINANCE Bank',
    'EJINDU MICROFINANCE BANK',
    'EMPIRE MFB',
    'EXCEL MICROFINANCE BANK',
    'EYOWO MICROFINANCE BANK',
    'Earnwell MICROFINANCE BANK',
    'EcoMobile',
    'Ecobank Bank',
    'Esan MFB',
    'FAIRMONEY MICROFINANCE BANK LT',
    'FBN Morgages Limited',
    'FBN merchant Bank',
    'FBNMobile',
    'FCMB',
    'FETS',
    'FEWCHORE FINANCE',
    'FIRST APPLE',
    'FORESIGHT MICROFINANCE BANK',
    'Fidelity Bank',
    'Fidelity Mobile',
    'First Bank of Nigeria',
    'First Inland Bank',
    'First Multiple MFB',
    'First Royal Microfinance Bank',
    'FortisMobile',
    'GARUN MALLAM MICROFINANCE BANK',
    'GDL FINANCE',
    'GOMBE MICROFINANCE BANK LIMITE',
    'GOOD SHEPHERD MICROFINANCE',
    'GOSIFECHUKWU MICROFINANCE',
    'GRANTS MICROFINANCE BANK',
    'GREENACRES MICROFINANCE BANK',
    'GREENVILLE MICROFINANCE BANK',
    'Gashua Microfinance Bank',
    'Globus Bank',
    'Sterling Mobile',
    'Good News Microfinance Bank',
    'HALO MICROFINANCE BANK',
    'HASAL MFB',
    'Hackman Microfinance Bank',
    'Hope PSB',
    'IBETO Microfinance Bank',
    'IBILE Microfinance Bank',
    'IKOYI ILE MFB',
    'ILISAN MICROFINANCE BANK',
    'IMSU MICROFINANCE BANK',
    'Imperial Homes Mortgage Bank',
    'Infinity MFB',
    'Intellifin',
    'Opay',
    'JubileeLife',
    'KADUPE MICROFINANCE BANK',
    'KAYI MICROFINANCE BANK',
    'KOLOMONI MICROFINANCE BANK',
    'LEADCITY MICROFINANCE BANKK',
    'unilorin Microfinance Bank',
    'Parallex Bank',
    'Parkway MF Bank',
    'Parkway-ReadyCash',
    'Parralex',
    'Peace Microfinance Bank',
    'Petra Microfinance Bank',
    'Polaris Bank',
    'Preeminent Microfinance Bank',
    'Providus Bank',
    'RANDALPHA MICROFINANCE BANK',
    'REGENT MFB',
    'REVELATION MICROFINANCE BANK',
    'REX Microfinance Ban',
    'RIGO Microfinance Bank',
    'ROCKSHIELD MICROFINANCE BANK',
    'RSU MICROFINANCE',
    'Rahama MFB',
    'Rand Merchant Bank',
    'Reliance MFB',
    'Rubies Microfinance Bank',
    'SHALOM MICROFINANCE BANK',
    'SIGNATURE BANK',
    'SIMPLIFY SYNERGY',
    'SOURCE MICROFINANCE BANK',
    'SPARKLE MICROFINANCE BANK',
    'SUNTOP MICROFINANCE BANK LIMIT',
    'SafeTrust',
    'Safegate Microfinance Bank',
    'Sagamu Microfinance Bank',
    'Seed Capital Microfinance Bank',
    'SmartCash PSB',
    'Spectrum Microfinance Bank',
    'Stanbic IBTC Virtual Banking',
    'StanbicIBTC Bank',
    'Standard Chartered Bank Ghana',
    'Standard MFB',
    'StandardChartered',
    'Stanford MFB',
    'Sterling Bank',
    'Sunbeam Microfinance Bank',
    'Suntrust Bank',
    'Support MF Bank',
    'TCF MF Bank',
    'TITAN TRUST BANK',
    'TITAN-PAYSTACK Microfinance',
    'TRIVES FINANCE',
    'TagPay',
    'Taj Bank',
    'TeasyMobile',
    'Trustbond',
    'United Bank for Africa',
    'UMUCHINEMERE PROCREDIT MFB',
    'UMUCHUKWU MICROFINANCE BANK',
    'UNIBEN MICROFINANCE BANK',
    'UNN MFB',
    'URE MICROFINANCE BANK',
    'UniUyo Microfinance Bank',
    'Unical MFB',
    'Union Bank',
    'Unity Bank',
    'Uzondu MF Bank',
    'VALE FINANCE',
    'VFD MFB',
    'WAYA MICRO FINANCE',
    'WESLEY MICROFINANCE BANK',
    'WETLAND MFB',
    'WRA MICROFINANCE BANK',
    'Wema Bank',
    'WinView Bank',
    'XPRESS WALLET',
    'Zenith Bank',
    'eNaira',
    'eTranzact',
    'Page MFBank',
    'PYRAMID MICROFINANCE BANK',
    'PRUDENT MICROFINANCE BANK',
    'PROSPECTS MICROFINANCE',
    'PREMIUMTRUST BANK',
    'POLYIBADAN MICROFINANCE BANK',
    'PFI FINANCE',
    'PATHFINDER MICROFINANCE BANK',
    'Oscotech MFB',
    'Optimus Bank',
    'OTUO MICROFINANCE BANK',
    'ORAUKWU MICROFINANCE BANK',
    'Momo Payment Service Bank',
    'NDDC MICROFINANCE BANK',
    'NET MICROFINANCE BANK',
    'NEXIM BANK',
    'NIGERIAN PRISONS MFB',
    'NUGGETS MICROFINANCE BANK',
    'Nomba financial services Limit',
    'OCTOPUS MICROFINANCE BANK',
    'ODOAKPU MICROFINANCE BANK',
    'OK MICROFINANCE',
    'OKENGWE MICROFINANCE BANK',
    'OMAK MICROFINANCE BANK',
    'BAINES CREDIT MICROFINANCE BANK',
    'CASHBRIDGE MICROFINANCE BANK',
    'DAVENPORT MICROFINANCE BANK',
    'ECOMOBILE',
    'FEWCHORE FINANCE COMAPNY LIMITED',
    'GOLDMAN MICROFINANCE BANK',
    'ISUA MFB',
    'ISUOFIA MICROFINANCE BANK',
    'Kenechukwu microfinance bank',
    'Moneymaster PSB',
    'Qube Microfinance Bank',
    'SEAP Microfinance Bank',
    'Taj_Pinspay',
    'TREASURES MICROFINANCE BANK',
    'UCEE MFB',
    'WESLEY MFB',
    'WUDIL MICROFINANCE BANK',
]
